module.exports = __webpack_public_path__ + "components/toggle-arrow/static/arrow-08b17dea0108d8c209339a182b0be1c9.svg";